import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';

import { Globals, Ref } from '../globals';

export interface Warehouse {
  active: number;
  createdAt: any;
  updatedAt: any;
  name: string;
  description: string;
  folio: string;

  products: ProductInStock[];
}

export interface WarehouseId extends Warehouse {
  id: string;
}

export interface ProductInStock {
  ref: Ref;
  quantity: number;
}

@Injectable()
export class WarehouseService {

  warehouseCollection: AngularFirestoreCollection<Warehouse>;
  warehouses: any;

  warehouseDocument: AngularFirestoreDocument<Warehouse>;
  warehouse: Observable<Warehouse>;

  collection: string;

  // NOTE: Change this any for Warehouse Interface
  warehouse$: Observable<any>;
  warehouses$: Observable<any[]>;

  constructor(
    private afs: AngularFirestore,
    public afh: FirestoreService,
    private router: Router,
  ) {
    this.collection = Globals.WAREHOUSE_COLLECTION;
  }

  /**
   * Get all warehouses with references
   * @return {Observable} Arrays of warehouses
   */
  getWarehouses() {
    return this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true) );
  }

  /**
  * Get warehouse data
  * @param {string} sid - The id of the warehouse
  * @return {Observable} The Warehouse Object
  */
  getWarehouse(sid: string) {
    return this.warehouse$ = this.afh.docWithIds$(this.collection + '/' + sid);
  }

  /**
  * Create new warehouse
  * @param {Warehouse} warehouse - The data of the warehouse
  */
  addWarehouse(warehouse: Warehouse) {
    this.afh.add(`${this.collection}`, warehouse);
    this.router.navigate(['/warehouse']);
  }

  /**
   * Update current warehouse
   * @param {string} sid  - The id of the warehouse
   * @param {Warehouse} warehouse - The data of the warehouse
   */
  updateWarehouse(sid: string, warehouse: Warehouse) {
    this.afh.update(`${this.collection}/${sid}`, warehouse);
    this.router.navigate(['/warehouse']);
  }

  /**
   * Update current warehouse's products
   * @param {string} sid  - The id of the warehouse
   * @param {ProductInStock} products - The products of the warehouse
   */
  updateWarehouseProducts(sid: string, products: ProductInStock[]) {
    let sub = this.getWarehouse(sid).subscribe(({...warehouse}: Warehouse) => {
      sub.unsubscribe();
      products.map(({ref, quantity}) => {
        let prAlreadyOnStock = warehouse.products.findIndex(product => product.ref.id == ref.id);
        if(prAlreadyOnStock == -1) warehouse.products.push( {ref, quantity} );
        else warehouse.products[prAlreadyOnStock].quantity += quantity;
      });
      this.afh.update(`${this.collection}/${sid}`, warehouse);
    });
  }

  /**
   * Delete current Warehouse
   * @param {string} sid - The id of the warehouse
   */
  deleteWarehouse(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

}
